import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, TableBody, TablePagination, TableRow, TableHead } from '@material-ui/core'
import MuiTableCell from '@material-ui/core/TableCell'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import './hover.css'
import { compFields } from './compFieldConstants'
import ApartmentIcon from '@material-ui/icons/Apartment'
import favIcon from './favicon.ico'
import TableContainer from '@material-ui/core/TableContainer'
import {
  formatDate, commaFormatted, distanceFromSubject, displayDateFormat,
  getPropertyTypeIcon
} from '../Utility/Utility'
import myContext from '../FiltersComponent/context/context'
import GetSearchResult from '../Utility/GetSearchResult/GetSearchResult'
import { sortArray } from '../../PropertyList/Utility/PropertyListUtility'
// import { currentENV } from '../Utility/Utility'
// import envConfig from '../../Common/envConfig/envConfig'

const TableCell = withStyles({
  root: {
    // fontSize: 'unset',
    // fontFamily: 'unset',
    // letterSpacing: 'unset',
    // fontWeight: 'unset',
    // lineHeight: 'unset',
    // borderBottom: 'unset'
  },
  head: {
    // lineHeight: 'unset'
  }
})(MuiTableCell)

const TableRowCell = withStyles(theme => ({
  // root: {
  //   '&:first-child': {
  //     backgroundColor: '#ffffff'
  //   },
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover
  //   } 
  // }
}))(TableRow)

const useStyles = makeStyles({
  container: {
    height: '100%'
  },
  header: {
    cursor: 'pointer'
  }
})

function translateData(item, tableData) {
  let str = tableData[item.key]
  switch (item.type) {
    case 'number':

      if (item.key === 'averageSizeSquareFeetPerUnit') {
        str = parseFloat(str) ? parseFloat(str).toFixed(0) : str
      }

      str = commaFormatted(str, false)
      // str = str.replace(/\$/g, '')
      break
    case 'currency':

      if (item.key === 'averageRentPerUnit' || item.key === 'averageRentPerBed' || item.key === 'propertyPricePerUnit') {
        str = parseFloat(str) ? parseFloat(str).toFixed(0) : str
      }

      str = commaFormatted(str, true)
      break
    case 'percent':
      str = `${str}%`
      break
    case 'date':
      //str = formatDate(str, 'mmDDYYYY')
      str = displayDateFormat(str)
      break
    default:
      str = tableData[item.key]
      if (item.key === 'yearBuilt') {
        let yearBuilt = str ? str : '-'
        let yearReno = tableData['yearRenovated'] ? tableData['yearRenovated'] : '-'
        str = `${yearBuilt} | ${yearReno}`
      }

    // if (item.key === 'datePutOnMarket') {
    //   let datePutOnMarket = str ? formatDate(str, 'mmDDYYYY') : '-'
    //   let datePutOffMarket = tableData['datePutOffMarket'] ? formatDate(tableData['datePutOffMarket'], 'mmDDYYYY') : '-'
    //   str = `${datePutOnMarket} | ${datePutOffMarket}`
    // }

    // if (item.key === 'propertyOnMarket') {
    //   str = str ? 'true' : 'false'
    // }

  }

  return str

}

function TableDataBuild({ tableData, labelId }) {
  const { preSearchCriteria, searchCriteria } = useContext(myContext)

  const getAddress = () => {
    let address = ''

    try {
      address = `${tableData.addressLine1} ${tableData.city ? tableData.city : ''}, ${tableData.state ? tableData.state : ''}, ${tableData.zipCode}`
      address = address.replace(',,', ',')
      address = address.replace(', ,', ',')
    } catch (error) {

    }

    return address
  }

  const getListing = () => {
    let listingStatus = ''
    try {
      if ((tableData.berkadiaListing === true || tableData.berkadiaListing === 'true') && (tableData.propertyOnMarket === true || tableData.propertyOnMarket === 'true')) {
        listingStatus = ' Berkadia Listing'
      }
      if ((tableData.berkadiaListing === false || tableData.berkadiaListing === 'false') && (tableData.propertyOnMarket === true || tableData.propertyOnMarket === 'true')) {
        listingStatus = ' Competitor Listing'
      }
      if (tableData.berkadiaBrokered === true || tableData.berkadiaBrokered === 'true') {
        listingStatus = ' Berkadia Brokered - Off market'
      }
    } catch (error) {
      console.log('getListingStatus = ', error)
    }
    return listingStatus
  }

  const getListingValue = () => {
    let listingStatusValue = ''
    try {
      if ((tableData.berkadiaListing === true || tableData.berkadiaListing === 'true') && (tableData.propertyOnMarket === true || tableData.propertyOnMarket === 'true')) {
        listingStatusValue = '1'
      }
      if ((tableData.berkadiaListing === false || tableData.berkadiaListing === 'false') && (tableData.propertyOnMarket === true || tableData.propertyOnMarket === 'true')) {
        listingStatusValue = '2'
      }
      if (tableData.berkadiaBrokered === true || tableData.berkadiaBrokered === 'true') {
        listingStatusValue = '3'
      }
    } catch (error) {
      console.log('getListingStatus = ', error)
    }
    return listingStatusValue
  }

  const tableBodyData = getSearchType(preSearchCriteria.searchType, searchCriteria).map((item, index) => {
    const sforceLink = `${window.REACT_GLOBAL_CONFIG.SF_URL}${tableData.omniViewPropertyId}`
    const sfAccountLink = `${window.REACT_GLOBAL_CONFIG.SF_URL}${tableData.salesforceAccountId}`
    const sfContactLink = `${window.REACT_GLOBAL_CONFIG.SF_URL}${tableData.salesforceContactId}`

    return (<>
      {item.key === 'propertyName' ? (
        <TableCell component="th" id={labelId} key={index} scope="row" padding="none" className="text-primary" >
          <div className="border-r-1 border-base pr-4 flex flex-col">
            <span className="truncate">
              <span className="pr-2 cursor-context-menu">
                <img title={tableData.omniViewPropertyType} width="22px" height="22px" src={getPropertyTypeIcon(tableData.omniViewPropertyType)}></img>
              </span>
              <a href={sforceLink} target="_blank" rel="noopener noreferrer">{tableData.propertyName} </a>
            </span>
            <span className="text-1 p-1 text-muted truncate">{getAddress()}</span>
            <span className="text-1 p-1 text-muted truncate">
              {getListingValue() === '1' ? <ApartmentIcon /> : getListingValue() === '2' || getListingValue() === '3' ? <img class="h-5" src={favIcon} alt="Logo" /> : ''}
              {getListing()}
            </span>
          </div>
          {/* <a href={sforceLink} target="_blank" rel="noopener noreferrer">{tableData.propertyName} </a> */}
        </TableCell>
      ) : (<>{
        <TableCell key={index} className={`px-4 align-middle ${item.type === 'text' ? '' : 'text-right'}`} >
          {item.key === 'salesforceAccountName' || item.key === 'salesforceContactName' ?
            <span >
              <a href={item.key === 'salesforceAccountName' ? sfAccountLink : sfContactLink} target="_blank" rel="noopener noreferrer">{tableData[item.key]} </a>
            </span> :
            <span >
              {(tableData[item.key] && tableData[item.key] !== undefined) ? translateData(item, tableData) : ''}
            </span>
          }

        </TableCell>
      }</>)
      }
    </>
    )
  })

  return <>{tableBodyData}</>
}

const getSearchType = (searchType, searchCriteria) => {

  let isStudentHousingOrHealthCare = false
  searchCriteria.propertyTypeFields.forEach((prop) => {
    if (prop.propertytype === "Student Housing" || prop.propertytype === "Health Care") {
      isStudentHousingOrHealthCare = true
    }
  })
  // let isListingSearch = searchCriteria.listingStatusFields.length > 0 ? true : false

  let selectedFields = compFields.filter(col => col.for.includes(searchType)) || []

  // if (isListingSearch) {
  //   // debugger
  //   let listingHeader = compFields.filter(col => col.for.includes('listing'))
  //   selectedFields = [...selectedFields, ...listingHeader]
  // }

  const excludeHeaders = [...(!searchCriteria.subjectProperty.omniViewPropertyId ? ['distanceFromSubject'] : []),
  ...(!isStudentHousingOrHealthCare ? ['totalBeds', 'averageRentPerBed', 'propertyPricePerBed'] : [])];
  return selectedFields.filter((item) => {
    return excludeHeaders.indexOf(item.key) == -1;
  })
}

export default function SearchResultTable() {
  const { savedSearch, setSavedSearch, searchResult, setSearchResult, searchCriteria, setSearchCriteria, preSearchCriteria, setInfoWindowToShow, showMap } = useContext(myContext)
  // const classes = useStyles()
  const propertyData = searchResult.property
  // propertyData = searchResult
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [isAllSelectedOnPage, setIsAllSelectedOnPage] = React.useState({});
  // const keycloak = useContext(AuthContext)


  // const [selected, setSelected] = React.useState([]);

  useEffect(() => {
    if (searchResult.property.length === 0) {
      // reset pagination back to 0th page
      setPage(0)
    }
    getSearchType(preSearchCriteria.searchType, searchCriteria).forEach((item) => {
      delete item.sortType
    })
    // const selectedList = savedSearch.filter((sItem) => { return sItem.isSelected })
    // if (selectedList && selectedList.length) {
    //   let properties = []
    //   selectedList[0].compsList.forEach((comp) => {
    //     const selProp = searchResult.property.filter((prop) => {
    //       return comp.omniViewPropertyId === prop.omniViewPropertyId
    //     })
    //     if (selProp && selProp.length) {
    //       selProp[0].checked = true
    //     }

    //     properties = [...selProp, ...properties]
    //   })
    //   setSearchResult({ property: properties, totalCount: searchResult.totalCount })
    // }
    // const newSavedSearch = [...savedSearch]
    // newSavedSearch.forEach((sItem) => {
    //   delete sItem.isSelected
    // })
    // setSavedSearch(newSavedSearch)

  }, [searchResult])

  const handleChangePage = (event, newPage) => {

    setPage(newPage)
    // scrollToElement('table-search-result')
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
    loadMoreSearchResult(newPage)
    // setPage(newPage)
  }

  const tableSort = tHeader => {
    try {
      getSearchType(preSearchCriteria.searchType, searchCriteria).forEach((item) => {
        delete item.sortType
      })
      const newSearchCriteria = { ...searchCriteria }
      const isMilesSortingApplied = (tHeader.key === 'distanceFromSubject') ? true : false
      const type = isMilesSortingApplied ? 'byMiles' : tHeader.key
      const searchType = newSearchCriteria.sort[type] && newSearchCriteria.sort[type]['order'] === 'asc' ? 'desc' : 'asc'
      if (isMilesSortingApplied && newSearchCriteria.sort[type]) {
        // if(){
        //   // newSearchCriteria.sort[type]['propertyLocation'] = newSearchCriteria.subjectProperty.propertyLocation
        newSearchCriteria.sort[type]['order'] = searchType

      } else {
        if (isMilesSortingApplied === false) {
          newSearchCriteria.sort = { [type]: { 'order': searchType } }
        }
      }

      newSearchCriteria.pagination = { 'from': 0, 'size': 100 }

      tHeader.sortType = searchType

      setSearchCriteria(newSearchCriteria)

      if (searchResult.totalCount > 100) {
        const newSearchResult = new GetSearchResult(newSearchCriteria, function (response, isError) {
          if (!isError) {
            if (response.data && response.data.data) {
              // console.log('im here')
              let data = response.data.data
              //data = searchResult.property.concat(data)
              if (searchCriteria.subjectProperty.propertyName) {
                data = distanceFromSubject(data, searchCriteria)
              }
              setSearchResult({ property: data, totalCount: response.data.total })
              setPage(0)
            }
          }
        })

        newSearchResult.fetchSearchResult()

      } else {
        let newProperty = [...searchResult.property]
        let subjectProperty = []
        if (searchCriteria.subjectProperty && searchCriteria.subjectProperty.omniViewPropertyId) {
          subjectProperty = newProperty.filter(x => x.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId)
          newProperty = newProperty.filter(x => x.omniViewPropertyId !== searchCriteria.subjectProperty.omniViewPropertyId)
        }

        newProperty = [...sortArray(newProperty, type, searchType)]

        if (searchCriteria.subjectProperty && searchCriteria.subjectProperty.omniViewPropertyId) {
          newProperty = [...subjectProperty, ...newProperty]
        }

        setSearchResult({ property: newProperty, totalCount: searchResult.totalCount })
      }
    } catch (error) {
      console.log('error in table sort::', error)
    }

  }

  const loadMoreSearchResult = (newPage, newRowsPerPage = rowsPerPage) => {
    // console.log(newRowsPerPage)
    try {
      const currentIndex = (newPage * newRowsPerPage) + (newRowsPerPage)
      if (currentIndex + newRowsPerPage > searchResult.property.length) {
        const newSearchCriteria = searchCriteria
        // const newFrom = newSearchCriteria.pagination.from + 100
        newSearchCriteria.pagination.from = newSearchCriteria.pagination.from + 100
        setSearchCriteria({ ...newSearchCriteria })
        const newSearchResult = new GetSearchResult(newSearchCriteria, function (response, isError) {
          if (!isError) {
            if (response.data && response.data.data) {
              // console.log('im here')
              let data = response.data.data
              data = searchResult.property.concat(data)
              if (searchCriteria.subjectProperty.propertyName) {
                data = distanceFromSubject(data, searchCriteria)
              }
              setSearchResult({ property: data, totalCount: response.data.total })
              setPage(newPage)
            }
          }
        })

        newSearchResult.fetchSearchResult()
      }
    } catch (error) {
      console.log('error in loadMoreSearchResult :::', error)
    }
  }

  const handleChangeRowsPerPage = event => {
    if (event && event.target) {
      const newRowsPerPage = parseInt(event.target.value, 10)
      setRowsPerPage(newRowsPerPage)
      setPage(0)
      loadMoreSearchResult(0, newRowsPerPage)
      setIsAllSelectedOnPage({})
      setSearchResult({property: searchResult.property.map(t => {
          t.checked = false;
          return t
        }), totalCount: searchResult.totalCount
      })
      // if(isAllSelectedOnPage) {
      //   const { property, totalCount } = searchResult
      //   property.slice((page * rowsPerPage), ((page+1) * newRowsPerPage)).forEach((prop) => {
      //     prop.checked = true
      //   })
      //   setSearchResult({ property, totalCount })
      // }
    }
  }

  const getSubjectPropertyId = () => {
    let subjectId = ''
    if (searchCriteria.subjectProperty.omniViewPropertyId) {
      subjectId = searchCriteria.subjectProperty.omniViewPropertyId
    }
    return subjectId
  }

  const updateInforWindowtoShow = omniViewPropertyId => {
    if (showMap) {
      setInfoWindowToShow(omniViewPropertyId)
    }
  }


  // const isSelected = (propId) => {


  //   return selected.indexOf(propId) !== -1
  // }
  const tableBodyContent = propertyData
    // eslint-disable-next-line no-mixed-operators
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((tableData, index) => {
      // const isItemSelected = isSelected(tableData.omniViewPropertyId)
      return (
        <TableRowCell onClick={() => { updateInforWindowtoShow(tableData.omniViewPropertyId) }} key={tableData.omniViewPropertyId} className="showAlways cursor-pointer">
          <TableCell>
            <span>
              <input checked={tableData.checked || getSubjectPropertyId() === tableData.omniViewPropertyId}
                disabled={getSubjectPropertyId() === tableData.omniViewPropertyId}
                onClick={(event) => handleClick(event, tableData.omniViewPropertyId)} type="checkbox"
                value={tableData.omniViewPropertyId} data-testid={tableData.omniViewPropertyId} />
            </span>
          </TableCell>
          <TableCell className="w-1">
            {getSubjectPropertyId() !== '' ? getSubjectPropertyId() === tableData.omniViewPropertyId ?
              <span className="badge bg-gray-80 text-white">S</span>
              : <span className="badge">{(page * rowsPerPage) + (index)}</span>
              : <span className="badge">{(page * rowsPerPage) + (index + 1)}</span>
            }
          </TableCell>
          <TableDataBuild tableData={tableData} comp="sales" />
        </TableRowCell>
      )
    })

  const getSortIcon = thead => {

    return (
      <>
        {searchCriteria.sort && searchCriteria.sort[thead.key] ?
          <span className='ml-2'><i className={`fa fa-sort-${searchCriteria.sort[thead.key].order}`}></i></span>
          : null}
      </>
    )
  }

  // const isAllSelected = () =>{
  //   const selectedPropertyCount = propertyData.map((prop)=>{
  //     return prop.checked
  //   })
  //   return propertyData.length > 0 && selectedPropertyCount === propertyData.length
  // }
  const tableHeaderData = getSearchType(preSearchCriteria.searchType, searchCriteria).map((item, index) => (
    <>
      {item.label === 'Property Name' ? (
        <TableCell onClick={() => { tableSort(item) }} className='font-bold cursor-pointer w-1/5' key={index}>
          {item.label}
          {getSortIcon(item)}
        </TableCell>
      ) : (
        <TableCell onClick={() => { tableSort(item) }}
          className={`font-bold cursor-pointer ${item.type === 'text' ? '' : 'text-right'} ${!item.sortType ? 'px-4 text-primary' : ''}`} key={index}>
          {item.label}
          {getSortIcon(item)}
        </TableCell>
      )}
    </>
  ))


  const handleSelectAllClick = (event) => {
    const { property, totalCount } = searchResult
    property.slice((page * rowsPerPage), ((page+1) * rowsPerPage)).forEach((prop) => {
      prop.checked = event.target.checked
      // if (prop.checked && selected.indexOf(prop.omniViewPropertyId) == -1) {
      //   selected.push(prop.omniViewPropertyId)
      // }
    })
    setSearchResult({ property, totalCount })
    setIsAllSelectedOnPage({...isAllSelectedOnPage, [page]: event.target.checked});
    // // setSelected(event.target.checked ? selected : [])
  }

  const handleClick = (event, propertyId) => {
    const { property, totalCount } = searchResult
    property.forEach((prop) => {
      if (prop.omniViewPropertyId === propertyId) {
        prop.checked = event.target.checked
        // if (prop.checked) {
        //   selected.push(prop.omniViewPropertyId)
        // } else {
        //   selected.splice(selected.indexOf(propertyId), 1)
        // }
      }
    })
    setSearchResult({ property, totalCount })
    // setSelected(selected)
  }

  // const isAllSelected = propertyData.filter(function (c) {
  //   return c.checked;
  // }).length === propertyData.length;
  return (
    // <div style={{ height: 'calc(100vh - 50vh)' }}>
    <>
      {propertyData.length &&
        <div>
          <div className="flex justify-between items-center">
            <h6 className="bold text-2 items-left pt-4">
              <span>
                {searchResult.totalCount}{searchResult.totalCount === 10000 ? '+' : ''} Comparable {preSearchCriteria.searchType} properties
              </span>
              {/* {searchResult.totalCount} Comparable {preSearchCriteria.searchType} properties */}
            </h6>
            <div>
              <h6 className="bold text-2 items-left pt-4">
              <span>
              Selected Properties: {searchResult.property.filter(row => row.checked).length === 0 ? 1 : searchResult.property.filter(row => row.checked).length} 
              </span>
            </h6>
            </div>
            <div className="items-right">
              {/* <span className="mt-2 mb-2 mr-2" />
              <ViewComfyIcon fontSize="small" /> */}
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={propertyData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <TableContainer className="h-full border-base border-1 w-full">
            <Table aria-label="simple table" className='text-2 table-responsive table-hover break-words table table-lg w-full'>
              <TableHead id="table-search-result" className="bg-gray-15 nowrap" >
                <TableRowCell>
                  {/* <TableCell className="w-1/4 px-4 py-2 bg-gray-20 border-none" /> */}
                  <TableCell padding="checkbox">
                    <span >
                    <input data-testid="test-check-all-properties" checked={isAllSelectedOnPage[page]} onChange={handleSelectAllClick} type="checkbox" value={isAllSelectedOnPage[page]} />
                    </span>
                  </TableCell>
                  <TableCell />
                  {tableHeaderData}
                  {/* <TableCell className="w-1/2 px-4 py-2 bg-gray-20 border-none" /> */}
                </TableRowCell>
              </TableHead>
              <TableBody>{tableBodyContent}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={propertyData.length}
            // count={searchResult.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      }
    </>

  )
}

SearchResultTable.propTypes = {
  rows: PropTypes.array
}

TableDataBuild.propTypes = {
  tableData: PropTypes.Object,
  labelId: PropTypes.string
}
